const MOBILE_BREAKPOINT = 920;

export function initHeader() {
    /** @type {HTMLDivElement} */
    const header = document.querySelector('.page-header');
    if (!header) {
        return;
    }

    /** @type {NodeListOf<HTMLLIElement>} */
    const navItems = header.querySelectorAll('.page-header-navigation-item');
    const subNav = header.querySelector('.page-header-subnav');
    /** @type {NodeListOf<HTMLDivElement>} */
    const subNavPanes = subNav.querySelectorAll('.page-header-subnav-pane');

    /** @type {HTMLLIElement | null} */
    let lastFocusedItem = null;

    for (const item of navItems) {
        item.addEventListener('pointerenter', () => {
            if (isMobile()) {
                return;
            }

            _open(item);
        });
        item.addEventListener('focusin', () => _open(item));

        /** @type {HTMLDivElement | undefined} */
        const connectedPane = [...subNavPanes].find(pane => pane.dataset.parentId === item.dataset.pageId);

        const hasChildren = item.classList.contains('page-header-navigation-item--has-children');

        if (hasChildren) {
            item.addEventListener('keydown', e => {
                if (e.code === 'Space') {
                    lastFocusedItem = item;
                    connectedPane.querySelector('a').focus();
                    e.preventDefault();
                }
            });
        }
    }

    for (const pane of subNavPanes) {
        pane.addEventListener('keydown', e => {
            if (e.code === 'Escape') {
                lastFocusedItem?.querySelector('a').focus();
                lastFocusedItem = null;
            }
        });
    }

    header.addEventListener('pointerleave', () => {
        if (isMobile()) {
            return;
        }

        _close();
    });
    header.addEventListener('focusout', e => {
        const isHeaderChild = !!e.target.closest('.page-header');
        if (!isHeaderChild) {
            _close();
        }
    });

    /**
     * @param {HTMLLIElement} item
     */
    function _open(item) {
        const hasChildren = item.classList.contains('page-header-navigation-item--has-children');

        header.classList.toggle('page-header--open', hasChildren);
        subNav.inert = !hasChildren;

        for (const i of navItems) {
            i.classList.toggle('page-header-navigation-item--active', i === item && hasChildren);
        }

        if (hasChildren) {
            for (const pane of subNavPanes) {
                pane.classList.toggle(
                    'page-header-subnav-pane--active',
                    pane.dataset.parentId === item.dataset.pageId,
                );
            }
        }
    }

    function _close() {
        header.classList.remove('page-header--open');
        subNav.inert = true;
        for (const item of navItems) {
            item.classList.remove('page-header-navigation-item--active');
        }

        if (isMobile()) {
            for (const pane of subNavPanes) {
                pane.classList.remove('page-header-subnav-pane--active');
            }
        }
    }

    /** @type {number | undefined} */
    let openRemoveTimeout;

    /** @type {HTMLButtonElement} */
    const burger = header.querySelector('.page-header-burger');
    burger.addEventListener('click', () => {
        const isOpen = header.classList.toggle('page-header--mobile-open');
        if (!isOpen) {
            clearTimeout(openRemoveTimeout);
            openRemoveTimeout = setTimeout(() => {
                header.classList.remove('page-header--open');
            }, 300);
        }
    });

    for (const item of navItems) {
        if (!item.classList.contains('page-header-navigation-item--has-children')) {
            continue;
        }

        item.querySelector('a')
            .addEventListener('click', e => {
                if (!isMobile()) {
                    return;
                }

                e.preventDefault();
                _open(item);
            });
    }

    /** @type {NodeListOf<HTMLButtonElement>} */
    const backButtons = header.querySelectorAll('.page-header-subnav-back');
    for (const button of backButtons) {
        button.addEventListener('click', _close);
    }
}

function isMobile() {
    return window.innerWidth <= MOBILE_BREAKPOINT;
}